import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function RequireAdmin({ children }) {
  const { admin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <section
        className="mx-auto max-w-[1360px] px-6 md:px-10 py-24"
        data-testid="admin-guard-loading"
      >
        <p className="font-body text-ink-soft">Checking session…</p>
      </section>
    );
  }

  if (!admin) {
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return children;
}
